if (
  !import.meta.env.VITE_COGNITO_USER_POOL_ID ||
  !import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID
) {
  throw new Error('Missing required Cognito environment variables');
}

const cognitoOAuthDomain = import.meta.env.VITE_COGNITO_OAUTH_DOMAIN;
const redirectSignInUrl = import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN;
const redirectSignOutUrl = import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_OUT;

if (cognitoOAuthDomain && (!redirectSignInUrl || !redirectSignOutUrl)) {
  throw new Error('OAuth redirect URLs are not configured.');
}

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      ...(cognitoOAuthDomain &&
        redirectSignInUrl &&
        redirectSignOutUrl && {
          loginWith: {
            oauth: {
              domain: cognitoOAuthDomain,
              scopes: ['email', 'openid', 'profile'],
              responseType: 'code',
              redirectSignIn: [redirectSignInUrl],
              redirectSignOut: [redirectSignOutUrl],
            },
          },
        }),
    },
  },
};

export default amplifyConfig;
